/**
 * External dependencies
 */
import React from "react";
import { connect } from "react-redux";

/**
 * Internal dependencies
 */
import Modal from "components/modal";
import { isModalVisible } from "state/ui/selectors";
import { createCloseModalAction } from "state/ui/actions";
import EditDashboardForm from "blocks/edit-dashboard-form";
import { getEditedId } from "state/ui/dashboard-form/selectors";

/**
 * Style dependencies
 */
import "./styles.scss";

const EditDashboardPopover = ({ dashboardId, isVisible, closeModal }) => {
  const title = dashboardId ? "Edit Deck" : "New Deck";

  return (
    <Modal
      title={title}
      className="edit-dashboard-popover"
      isVisible={isVisible}
      close={closeModal}
    >
      <EditDashboardForm onCancel={closeModal} afterSave={closeModal} />
    </Modal>
  );
};

export default connect(
  (state) => ({
    isVisible: isModalVisible("EditDashboardPopover")(state),
    dashboardId: getEditedId(state),
  }),
  {
    closeModal: createCloseModalAction("EditDashboardPopover"),
  }
)(EditDashboardPopover);
